$(function () {
   console.log('Hello World'); 
   if (window.location.hash === '#jscViewSpecs') {
      expandFindInStore();
    }
});
viewSpecs = () =>{
 
   var anchr = $('#jscViewSpecs').parent();
  
    if (anchr.length > 0) {
     $('html').animate({
         scrollTop: $("#jscViewSpecs").offset().top - 168
     }, 1000);

    }
  
  } 

  // START AUTOPLAY VIDEO SECTION
  
  document.addEventListener('DOMContentLoaded', function() {
    // Find all video sections
    var videoSections = document.querySelectorAll('.vvideo');

    // Loop through each video section
    videoSections.forEach(function(section) {
        // Find the autoplay video iframe within this section
        var autoplayIframe = section.querySelector('.autoplay-video');

        // If an autoplay video iframe is found, start autoplay
        if (autoplayIframe) {
            // Autoplay the video by replacing the iframe source
            autoplayIframe.src = autoplayIframe.getAttribute('data-src');
            autoplayIframe.parentNode.classList.add('is-playing');
        }
    });
});
// END AUTOPLAY VIDEO SECTION

//start: refresh page
refreshPage = () => {
    setTimeout(function(){
        location.reload();
    },500);
    
}
//end: refresh page

//start: update pricing table in pdp
jscUpdatePricingTable = (e) => {
  var $pricingTable = $('.vol-pricing_table');

  setTimeout(function () {
    var $url = window.location.href;
    var $splitUrl = $url.split("variant=");
    var $getVarID = $splitUrl.length > 1
      ? $splitUrl[1].split("&")[0]
      : null;

    if (
      !$getVarID &&
      window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta
    ) {
      $getVarID = String(
        window.ShopifyAnalytics.meta.selectedVariantId
      );
    }

    if (!$getVarID) {
      $getVarID = $('[data-variant-id]')
        .first()
        .attr('data-variant-id');
    }

    if (!$getVarID) {
      return;
    }

    $pricingTable.find('ul').empty();

    $('.jsc-variant-vol-pricing .jsc-each-var-vol-pricing').each(function () {
      var $thisId = $(this).attr('data-var-id');

      if ($thisId == $getVarID) {
        $(this).children().each(function () {
          var $thisSeq = $(this).attr('data-seq');
          var $thisSeqQty = $(this).attr('data-min-qty');
          var $thisSeqPrice = $(this).attr('data-price');

          var html =
            '<li class="jsc-vol-pricing-list" data-seq="' +
            $thisSeq +
            '">' +
            '<span class="volume_pricing">' +
            $thisSeq +
            '</span>' +
            '<span class="quantity">' +
            $thisSeqQty +
            '<a aria-hidden="true">+</a></span>' +
            '<span class="pricing">' +
            $thisSeqPrice +
            '</span>' +
            '</li>';

          $pricingTable.find('ul').append(html);
        });
      }
    });
  }, 300);
};
//end: update pricing table in pdp
//start: request price & lead time button
function jscUpdateRequestPriceButton() {
  var requestButton = document.querySelector('.product-form__request-button');
  var addButton = document.querySelector('.product-form__add-button');

  if (!requestButton || !addButton) {
    return;
  }

  var isSoldOut =
    addButton.disabled &&
    addButton.textContent.trim().toLowerCase().indexOf('sold out') !== -1;

  if (!isSoldOut) {
    requestButton.style.display = 'none';
    return;
  }

  var urlParams = new URLSearchParams(window.location.search);
  var variantId = urlParams.get('variant') || '';

  var skuElement = document.querySelector('.product-meta__sku-number');
  var sku = skuElement ? skuElement.textContent.trim() : '';

  var selectedValue = document.querySelector('.product-form__selected-value');
  var size = selectedValue ? selectedValue.textContent.trim() : '';

var quantityInput = document.querySelector('input[name="quantity"]');
var quantity = quantityInput ? quantityInput.value : 1;

var productTitleElement = document.querySelector('.product-meta__title');
var productName = productTitleElement
  ? productTitleElement.textContent.trim()
  : '';

var requestUrl =
'/pages/product-request' +
    '?request=manufacture' +
    '&variant=' + encodeURIComponent(variantId) +
    '&sku=' + encodeURIComponent(sku) +
    '&size=' + encodeURIComponent(size) +
'&qty=' + encodeURIComponent(quantity) +
'&product_name=' + encodeURIComponent(productName) +
'&product_url=' + encodeURIComponent(window.location.href);

  requestButton.href = requestUrl;
  requestButton.style.display = 'block';
}

document.addEventListener('variant:changed', function () {
  setTimeout(jscUpdateRequestPriceButton, 50);
});

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(jscUpdateRequestPriceButton, 100);
});
//end: request price & lead time button

// ======================================================
// KINZI - LIMIT PRODUCT QUANTITY TO AVAILABLE STOCK
// ======================================================

function jscUpdateProductQuantityLimit() {
  var quantityInput = document.querySelector(
    '.quantity-selector--product .quantity-selector__value'
  );

  var inventoryMapElement = document.querySelector(
    '[data-variant-inventory-map]'
  );

  var variantInput = document.querySelector(
    'form[action*="/cart/add"] input[name="id"]'
  );

  if (!quantityInput || !inventoryMapElement || !variantInput) {
    return;
  }

  var inventoryMap;

  try {
    inventoryMap = JSON.parse(inventoryMapElement.textContent);
  } catch (error) {
    console.error('KINZI inventory map error:', error);
    return;
  }

  var variantId = String(variantInput.value);
  var inventory = inventoryMap[variantId];

  if (!inventory) {
    return;
  }

  // Product inventory is tracked
  if (inventory.tracked) {
    var availableStock = parseInt(inventory.quantity, 10);

    if (availableStock > 0) {
      quantityInput.setAttribute('max', availableStock);

      if (parseInt(quantityInput.value, 10) > availableStock) {
        quantityInput.value = availableStock;
      }
    } else {
      quantityInput.setAttribute('max', 0);
    }
  } else {
    // Inventory is not tracked: do not impose a maximum
    quantityInput.removeAttribute('max');
  }
}


// Prevent manual typing above available stock
document.addEventListener('input', function (event) {
  if (!event.target.matches(
    '.quantity-selector--product .quantity-selector__value'
  )) {
    return;
  }

  var input = event.target;
  var max = parseInt(input.getAttribute('max'), 10);
  var value = parseInt(input.value, 10);

  if (!isNaN(max) && max > 0 && value > max) {
    input.value = max;
  }

  if (value < 1) {
    input.value = 1;
  }
});


// Stop + button when quantity has reached available stock
document.addEventListener('click', function (event) {
  var plusButton = event.target.closest(
    '[data-action="increase-picker-quantity"]'
  );

  if (!plusButton) {
    return;
  }

  var selector = plusButton.closest('.quantity-selector--product');

  if (!selector) {
    return;
  }

  var input = selector.querySelector('.quantity-selector__value');

  if (!input) {
    return;
  }

  var max = parseInt(input.getAttribute('max'), 10);
  var current = parseInt(input.value, 10);

  if (!isNaN(max) && max > 0 && current >= max) {
    event.preventDefault();
    event.stopImmediatePropagation();
    input.value = max;
  }
}, true);


// Update maximum when customer changes variant / size
document.addEventListener('variant:changed', function () {
  setTimeout(jscUpdateProductQuantityLimit, 50);
});


// Set maximum when product page first loads
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(jscUpdateProductQuantityLimit, 100);
});

// ======================================================
// KINZI - GLOBAL INVENTORY PROTECTION
// Product page + Add to Cart
// ======================================================

function jscGetInventoryMap() {
  var el = document.querySelector('[data-variant-inventory-map]');

  if (!el) return null;

  try {
    return JSON.parse(el.textContent);
  } catch (error) {
    console.error('KINZI inventory map error:', error);
    return null;
  }
}


function jscGetCurrentVariantId(inventoryMap) {
  // First try URL
  var params = new URLSearchParams(window.location.search);
  var urlVariant = params.get('variant');

  if (urlVariant && inventoryMap[urlVariant]) {
    return String(urlVariant);
  }

  // Then find Shopify variant selector/input
  var variantInputs = document.querySelectorAll(
    'form[action*="/cart/add"] [name="id"], [name="id"]'
  );

  for (var i = 0; i < variantInputs.length; i++) {
    var id = String(variantInputs[i].value);

    if (inventoryMap[id]) {
      return id;
    }
  }

  return '';
}


async function jscGetCartQuantity(variantId) {
  try {
    var response = await fetch('/cart.js', {
      headers: {
        'Accept': 'application/json'
      }
    });

    var cart = await response.json();
    var quantity = 0;

    cart.items.forEach(function (item) {
      if (String(item.variant_id) === String(variantId)) {
        quantity += item.quantity;
      }
    });

    return quantity;

  } catch (error) {
    console.error('KINZI cart check error:', error);
    return 0;
  }
}


async function jscUpdateProductQuantityLimit() {
  var input = document.querySelector(
    '.quantity-selector--product .quantity-selector__value'
  );

  var inventoryMap = jscGetInventoryMap();

  if (!input || !inventoryMap) return;

  var variantId = jscGetCurrentVariantId(inventoryMap);

  if (!variantId || !inventoryMap[variantId]) {
    console.warn('KINZI: current variant not found');
    return;
  }

  var inventory = inventoryMap[variantId];

  // Not tracked = no maximum
  if (!inventory.tracked) {
    input.removeAttribute('max');
    return;
  }

  var stock = parseInt(inventory.quantity, 10) || 0;
  var alreadyInCart = await jscGetCartQuantity(variantId);

  // Important:
  // customer can add only what remains after cart quantity
  var remaining = Math.max(stock - alreadyInCart, 0);

  input.setAttribute('max', remaining);
  input.dataset.availableStock = stock;
  input.dataset.cartQuantity = alreadyInCart;
  input.dataset.remainingStock = remaining;

  var current = parseInt(input.value, 10);

  if (remaining > 0) {
    if (isNaN(current) || current < 1) {
      input.value = 1;
    }

    if (current > remaining) {
      input.value = remaining;
    }
  }

  console.log(
    'KINZI STOCK:',
    'variant=' + variantId,
    'stock=' + stock,
    'cart=' + alreadyInCart,
    'remaining=' + remaining
  );
}


function jscClampProductQuantity(input) {
  if (
    !input ||
    !input.matches('.quantity-selector--product .quantity-selector__value')
  ) {
    return;
  }

  var max = parseInt(input.getAttribute('max'), 10);
  var value = parseInt(input.value, 10);

  if (isNaN(value)) return;

  if (!isNaN(max) && value > max) {
    input.value = max;
  }

  if (value < 1 && max > 0) {
    input.value = 1;
  }
}


// Manual typing
document.addEventListener('input', function (event) {
  jscClampProductQuantity(event.target);
});

document.addEventListener('change', function (event) {
  jscClampProductQuantity(event.target);
});


// Stop PLUS before theme increases quantity
document.addEventListener('click', function (event) {
  var plus = event.target.closest(
    '.quantity-selector--product [data-action="increase-picker-quantity"]'
  );

  if (!plus) return;

  var selector = plus.closest('.quantity-selector--product');
  var input = selector
    ? selector.querySelector('.quantity-selector__value')
    : null;

  if (!input) return;

  var max = parseInt(input.getAttribute('max'), 10);
  var value = parseInt(input.value, 10) || 0;

  if (!isNaN(max) && value >= max) {
    event.preventDefault();
    event.stopImmediatePropagation();

    if (max > 0) {
      input.value = max;
    }

    return false;
  }
}, true);


// BLOCK Add to Cart if quantity exceeds remaining stock
document.addEventListener('click', function (event) {
  var addButton = event.target.closest(
    '[data-action="add-to-cart"]'
  );

  if (!addButton) return;

  var input = document.querySelector(
    '.quantity-selector--product .quantity-selector__value'
  );

  if (!input) return;

  var max = parseInt(input.getAttribute('max'), 10);
  var value = parseInt(input.value, 10);

  if (isNaN(max)) return;

  if (max <= 0) {
    event.preventDefault();
    event.stopImmediatePropagation();

    alert(
      'All available stock is already in your cart. Please use Request More Quantity for additional units.'
    );

    return false;
  }

  if (value > max) {
    event.preventDefault();
    event.stopImmediatePropagation();

    input.value = max;

    alert(
      'Only ' + max +
      ' additional units are currently available.'
    );

    return false;
  }

  // After successful add, recalculate remaining stock
  setTimeout(function () {
    jscUpdateProductQuantityLimit();
  }, 1000);

}, true);


// Variant / Size changed
document.addEventListener('variant:changed', function () {
  setTimeout(function () {
    jscUpdateProductQuantityLimit();
  }, 100);
});


// Initial page load
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    jscUpdateProductQuantityLimit();
  }, 200);
});

// ======================================================
// KINZI - MINI CART QUANTITY PROTECTION
// ======================================================

function jscClampMiniCartQuantity(input) {
  if (!input || !input.matches('.mini-cart .quantity-selector__value')) {
    return;
  }

  var max = parseInt(input.getAttribute('max'), 10);
  var value = parseInt(input.value, 10);

  if (isNaN(value)) {
    return;
  }

  if (!isNaN(max) && value > max) {
    input.value = max;
  }

  if (value < 0) {
    input.value = 0;
  }
}

document.addEventListener('input', function (event) {
  jscClampMiniCartQuantity(event.target);
});

document.addEventListener('change', function (event) {
  jscClampMiniCartQuantity(event.target);
});

// ======================================================
// KINZI - REQUEST MORE QUANTITY BUTTON
// ======================================================

function jscUpdateRequestMoreQuantityButton() {
  var button = document.querySelector('[data-request-more-quantity]');

  if (!button) {
    return;
  }

  var params = new URLSearchParams(window.location.search);

  var productTitleElement =
    document.querySelector('.product-meta__title') ||
    document.querySelector('.product-meta h1') ||
    document.querySelector('h1');

  var productName = productTitleElement
    ? productTitleElement.textContent.trim()
    : '';

  var skuElement = document.querySelector('.product-meta__sku-number');
  var sku = skuElement ? skuElement.textContent.trim() : '';

  var selectedValue = document.querySelector('.product-form__selected-value');
  var size = selectedValue ? selectedValue.textContent.trim() : '';

  var quantityInput = document.querySelector(
    '.quantity-selector--product .quantity-selector__value'
  );

  var quantity = quantityInput ? quantityInput.value : '1';

  var inventoryMap = jscGetInventoryMap();

  var variantId = inventoryMap
  ? jscGetCurrentVariantId(inventoryMap)
  : (params.get('variant') || '');

  var availableStock = '';

  if (
    inventoryMap &&
    variantId &&
    inventoryMap[String(variantId)]
  ) {
    availableStock = inventoryMap[String(variantId)].quantity;
  }

  var requestUrl =
    '/pages/product-request' +
    '?request=more_quantity' +
    '&variant=' + encodeURIComponent(variantId) +
    '&sku=' + encodeURIComponent(sku) +
    '&size=' + encodeURIComponent(size) +
    '&qty=' + encodeURIComponent(quantity) +
    '&available_stock=' + encodeURIComponent(availableStock) +
    '&product_name=' + encodeURIComponent(productName) +
    '&product_url=' + encodeURIComponent(window.location.href);

  button.href = requestUrl;
}


// First page load
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    jscUpdateRequestMoreQuantityButton();
  }, 300);
});


// When variant / size changes
document.addEventListener('variant:changed', function () {
  setTimeout(function () {
    jscUpdateRequestMoreQuantityButton();
  }, 150);
});


// When quantity changes
document.addEventListener('input', function (event) {
  if (
    event.target.matches(
      '.quantity-selector--product .quantity-selector__value'
    )
  ) {
    jscUpdateRequestMoreQuantityButton();
  }
});